export enum StepSettingsSubset {
  TOOL = 'tool',
  CASE = 'case',
  ANSWER = 'answer',
  MESSAGE_CAROUSEL = 'messageCarousel',

  DEFAULT_CASE = 'defaultCase',
  DEFAULT_ANSWER = 'defaultAnswer',

  MUTATIONS = 'mutations',
  ANSWER_ITEM_MUTATIONS = 'answerItemMutations',
  MESSAGE_CAROUSEL_ITEM_MUTATIONS = 'messageCarouselItemMutations'
}
